import React, { useEffect, useRef, useState, useMemo } from "react";
import apiRoutes from "../../api/apiRoutes";
import { apiFetchJson } from "../../utils/http";

export default function EstadoSelect({
  value,
  onChange,
  tipoId,
  disabled = false,
  autoLoad = true,
  excludeIds = [],
}) {
  const boxRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const outside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", outside);
    return () => document.removeEventListener("mousedown", outside);
  }, []);

  const load = async () => {
    if (loading || !tipoId) return;
    setLoading(true);
    try {
      const data = await apiFetchJson(
        `${apiRoutes.estado.autocomplete()}?tipoId=${tipoId}`
      );
      setItems(data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoLoad && items.length === 0 && tipoId) {
      load();
    }
    // eslint-disable-next-line
  }, [autoLoad, tipoId]);

  const filteredItems = useMemo(() => {
    if (!excludeIds || excludeIds.length === 0) return items;
    return items.filter((it) => !excludeIds.includes(it.id));
  }, [items, excludeIds]);

  const toggle = () => {
    if (disabled || !tipoId) return;
    setOpen((prev) => !prev);
    if (items.length === 0) load();
  };

  return (
    <div ref={boxRef} className="relative w-full">

      {/* INPUT VISUAL */}
      <div
        onClick={toggle}
        className={`
          w-full
          bg-white
          border border-gray-300
          rounded-full
          px-4
          flex items-center justify-between
          transition-all
          ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
          ${open
            ? "ring-2 ring-green-500 border-green-500"
            : "hover:border-gray-400"}
        `}
        style={{ minHeight: 42 }}
      >
        {value ? (
          <span className="text-gray-900">{value.label}</span>
        ) : (
          <span className="text-gray-400">
            -- Seleccionar estado --
          </span>
        )}

        <svg
          className="w-4 h-4 text-gray-500 ml-2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {open && (
        <div className="absolute z-40 mt-1 w-full bg-white border border-gray-300 rounded-xl shadow-md max-h-64 overflow-auto">

          <div
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600"
            onClick={() => {
              onChange?.(null);
              setOpen(false);
            }}
          >
            -- Todos --
          </div>

          {filteredItems.map((it) => (
            <div
              key={it.id}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                onChange?.(it);
                setOpen(false);
              }}
            >
              {it.label}
            </div>
          ))}

          {!loading && filteredItems.length === 0 && (
            <div className="px-4 py-2 text-gray-400">
              Sin resultados
            </div>
          )}
        </div>
      )}
    </div>
  );
}
